
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ICol } from './PublicTable'
@Component({
  name: 'PublicTableItem',
})
export default class PublicTableItem extends Vue {
  @Prop({ type: Object }) col!: ICol
  /** col 最小宽度 */
  @Prop({ type: [String, Number], default: '100' }) colMinWidth!: string | number
}
